import {
    Button,
    Form,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    ModalTitle
} from "react-bootstrap";
import Style from "./NewStepCombinationModal.module.css"
import React, {useState} from "react";
import {createNewCombination} from "../api/UserService";
import * as UserService from "../api/UserService";
import {trySetTimeout} from "../hooks/trySetTiemout";
import {useTranslation} from "react-i18next";

function NewStepCombinationModal(props) {
    const { t } = useTranslation('translation', { keyPrefix: 'newStepCombinationModal' });
    const defaultSteps = () => {
        return (
            <div>
                <div className={Style.step}>
                    <input type="number" placeholder={t('cellNumber')}></input>
                    <div>⮕</div>
                </div>
            </div>
        )
    }

    const [steps, setSteps] = useState([defaultSteps()])
    const [description, setDescription] = useState(undefined)
    const [isSaved, setIsSaved] = useState(false)
    let numberOfSteps = 0

    function deleteLastStep() {
        if (steps.length > 1) {
            setSteps(steps.slice(0, -1))
        }
    }

    function addOneStep(item) {
        numberOfSteps += 1
        setSteps([...steps, defaultSteps(item)])
    }

    function readStepValues() {
        let elements = [...document.querySelectorAll('#steps input')]
        let elementsValues = []
        elements.forEach(
            element => {
                elementsValues.push(element.value)
            }
        )
        return elementsValues

    }

    function saveCombinationDescription(event) {
        setDescription(event.target.value)
    }

    function saveCombination() {
        let elementsValues = readStepValues()
        if (elementsValues.length > 1) {
            UserService.createNewCombination(readStepValues(), description, () => {
                setIsSaved(true)
                trySetTimeout(() => {
                    setIsSaved(false)
                    props.onClose()
                }, 1000)
                props.pullAllCombinations()
            }, (response) => {
                alertCombinationExists(response)
            })
        }
    }

    function updateCombination() {
        let uiElements = readStepValues()
        let elementsValues = (uiElements.length === 1 && uiElements[0] === '') ? props.combination.sequence : uiElements

        UserService.updateCombination(props.combination.id, elementsValues, description, () => {
            setIsSaved(true)
            trySetTimeout(() => {
                setIsSaved(false)
                props.onClose()
            }, 1000)
            props.pullAllCombinations()
        }, (response) => {
            alertCombinationExists(response)
        })
    }

    function alertCombinationExists(response) {
        if (response.status === 409) {
            window.alert(t('combinationAlreadyExist'))
        }
    }

    return (
        <Modal
            show={true}
            onHide={props.onClose}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <ModalHeader closeButton>
                <ModalTitle>{props?.combination?.id === undefined ? t('newCombination') : props?.sequenceText}</ModalTitle>
            </ModalHeader>
            <ModalBody style={{backgroundColor: "white"}}>
                <div>
                    <label htmlFor={"steps"}>{t('combinationCells')}</label>
                    <div className={Style.steps} id={"steps"}>
                        {steps}
                        <div className={Style.buttonsContainer}>
                            <div className={Style.removeButton} onClick={deleteLastStep}></div>
                            <div className={Style.addButton} onClick={addOneStep}></div>
                        </div>
                    </div>
                </div>
                <Form.Group className="mb-3">
                    <Form.Label></Form.Label>
                    <Form.Control
                        placeholder={t('combinationDescription')}
                        as="textarea"
                        autoFocus
                        defaultValue={props?.combination?.text}
                        id={"userDescription"}
                        onInput={e => saveCombinationDescription(e)}
                    />
                </Form.Group>
            </ModalBody>

            <ModalFooter>
                <Button variant="primary" style={{backgroundColor: '#7749F8'}} onClick={props.onClose}>
                    {t('close')}
                </Button>
                <Button variant="primary" style={isSaved ? {backgroundColor: "green"} : {backgroundColor: "#7749F8"}}
                        onClick={props?.combination?.id === undefined ? saveCombination : updateCombination}>
                    {isSaved ? t('saved') : t('save')}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default NewStepCombinationModal